/**
 * 霍兰德职业建议动态生成 - 规则数据库
 * 
 * 这个文件包含所有用于动态生成建议的规则、映射表和模板
 */

// ==================== 1. 专业选择规则 ====================

// 每个类型的核心专业
export const MAJOR_BY_TYPE = {
  R: {
    core: ['机械工程', '电气工程', '土木工程', '建筑工程'],
    extended: ['汽车工程', '材料科学', '精密仪器', '测控技术'],
    keywords: ['技术', '动手', '实操', '工程']
  },
  I: {
    core: ['计算机科学', '数据科学', '统计学', '生物科学'],
    extended: ['物理学', '化学', '医学研究', '心理学'],
    keywords: ['研究', '分析', '探索', '钻研']
  },
  A: {
    core: ['艺术设计', '视觉传达', '数字媒体', '产品设计'],
    extended: ['服装设计', '动画', '音乐', '戏剧影视'],
    keywords: ['创意', '美感', '表达', '艺术']
  },
  S: {
    core: ['教育学', '心理学', '社会工作', '护理学'],
    extended: ['学前教育', '特殊教育', '康复治疗', '人力资源'],
    keywords: ['服务', '沟通', '帮助', '关怀']
  },
  E: {
    core: ['工商管理', '市场营销', '国际贸易', '金融学'],
    extended: ['法学', '政治学', '公共管理', '创业管理'],
    keywords: ['管理', '领导', '商业', '影响']
  },
  C: {
    core: ['会计学', '审计学', '财务管理', '档案学'],
    extended: ['行政管理', '信息管理', '统计学', '图书馆学'],
    keywords: ['规范', '精确', '流程', '系统']
  }
};

// 组合特征描述
export const COMBO_FEATURES = {
  RI: { desc: '既能动手又能钻研', majors: ['工业设计', '建筑学', '计算机科学'] },
  RA: { desc: '既能实操又有创意', majors: ['产品设计', '工业设计', '建筑设计'] },
  RS: { desc: '既能做技术又能帮助人', majors: ['医学技术', '康复治疗', '职业技术教育'] },
  RE: { desc: '既有技术又有管理', majors: ['工程管理', '项目管理', '信息管理'] },
  RC: { desc: '既能实操又重细节', majors: ['精密仪器', '测控技术', '质量管理'] },
  
  IA: { desc: '既善钻研又有创意', majors: ['交互设计', '用户研究', '游戏设计'] },
  IS: { desc: '既会研究又善沟通', majors: ['心理学', '教育学', '医学研究'] },
  IE: { desc: '既会分析又懂商业', majors: ['数据科学', '商业分析', '金融工程'] },
  IC: { desc: '既善研究又重规范', majors: ['统计学', '精算学', '信息安全'] },
  
  AS: { desc: '既有创意又善交流', majors: ['传媒', '广告学', '艺术教育'] },
  AE: { desc: '既有创意又懂经营', majors: ['文化产业管理', '艺术管理', '品牌设计'] },
  AC: { desc: '既有美感又重细节', majors: ['建筑学', '城市规划', '展示设计'] },
  
  SE: { desc: '既善沟通又会管理', majors: ['人力资源', '公共管理', '教育管理'] },
  SC: { desc: '既能服务又重流程', majors: ['行政管理', '社会保障', '公共事业管理'] },
  
  EC: { desc: '既会管理又重规范', majors: ['运营管理', '财务管理', '审计学'] }
};

// 院校类型推荐
export const SCHOOL_TYPE_BY_PRIMARY = {
  R: '理工类院校或综合性大学',
  I: '985/211研究型大学或科研院所',
  A: '艺术类院校或综合性大学艺术学院',
  S: '师范类院校或综合性大学',
  E: '综合性大学或财经类院校',
  C: '财经类院校或综合性大学'
};

// ==================== 2. 大学规划规则 ====================

export const COLLEGE_ACTIVITIES = {
  R: {
    year12: ['多做项目', '参加实验室', '学习专业工具和设备', '考取技能证书'],
    year3: ['找工程类实习', '参与实际项目', '积累动手经验'],
    year4: ['投工程师岗位', '技术岗位', '制造类企业']
  },
  I: {
    year12: ['参与科研项目', '多阅读专业文献', '学习数据分析工具', '参加学术竞赛'],
    year3: ['找研发实习', '实验室助理', '数据分析实习'],
    year4: ['投研究员', '数据科学家', '算法工程师']
  },
  A: {
    year12: ['建立作品集', '学习设计软件', '多创作多展览', '参加设计比赛'],
    year3: ['找设计公司实习', '工作室学习', '接私单积累经验'],
    year4: ['投设计师', '创意岗位', '可以考虑自由职业']
  },
  S: {
    year12: ['多参加志愿者活动', '参加社团锻炼沟通', '考教师资格证', '学习心理学知识'],
    year3: ['找教育机构实习', '医疗机构见习', '社会工作实习'],
    year4: ['投教师岗位', '咨询师', '社工', '人力资源']
  },
  E: {
    year12: ['参加学生会、社团', '组织活动锻炼领导力', '多参加商业比赛', '建立人脉网络'],
    year3: ['找管培生实习', '销售实习', '创业尝试'],
    year4: ['投管理岗', '销售岗', '管培生项目']
  },
  C: {
    year12: ['考专业证书（会计证等）', '学习办公软件', '培养细节管理能力', '学习财务知识'],
    year3: ['找财务实习', '行政实习', '事务所实习'],
    year4: ['投会计', '审计', '行政专员']
  }
};

// ==================== 3. 薪资预期数据 ====================

export const SALARY_DATA = {
  R: {
    fresh: { min: 7, max: 15, note: '技术岗位' },
    mid: { min: 12, max: 25, note: '3-5年经验' },
    context: '制造业、工程类企业，技术越深收入越高'
  },
  I: {
    fresh: { min: 10, max: 20, note: '研发岗位' },
    mid: { min: 18, max: 40, note: '3-5年经验' },
    context: '互联网、科研机构，顶尖人才收入更高'
  },
  A: {
    fresh: { min: 6, max: 15, note: '设计岗位' },
    mid: { min: 12, max: 30, note: '3-5年经验' },
    context: '设计行业，收入波动大，看作品和名气'
  },
  S: {
    fresh: { min: 5, max: 12, note: '教育/服务岗位' },
    mid: { min: 10, max: 20, note: '3-5年经验' },
    context: '教育、医疗、社工，稳定但天花板相对较低'
  },
  E: {
    fresh: { min: 8, max: 18, note: '管理/销售岗位' },
    mid: { min: 20, max: 50, note: '3-5年经验' },
    context: '销售、管理岗，提成占比大，能力强收入高'
  },
  C: {
    fresh: { min: 6, max: 12, note: '财务/行政岗位' },
    mid: { min: 10, max: 20, note: '3-5年经验' },
    context: '财务、行政类，收入稳定但增长较慢'
  }
};

// 组合职业薪资调整
export const COMBO_SALARY_MODIFIER = {
  RI: { multiplier: 1.2, note: '技术+研究岗位收入较高' },
  RE: { multiplier: 1.3, note: '技术管理岗收入更高' },
  IE: { multiplier: 1.4, note: '商业分析、数据科学收入很高' },
  EA: { multiplier: 1.1, note: '创意管理岗收入不错' },
  AS: { multiplier: 0.9, note: '艺术教育收入相对较低但稳定' }
};

// ==================== 4. 考研建议规则 ====================

export const GRADUATE_RULES = {
  // 强烈建议考研的组合
  recommend: {
    conditions: [
      { primary: 'I', reason: '研究类岗位非常看重学历，硕士是基本门槛' },
      { combo: 'RI', reason: '深入技术研发需要系统的理论基础' },
      { combo: 'IS', reason: '想当大学老师或进三甲医院，需要硕士甚至博士' },
      { combo: 'IC', reason: '精密技术、科研岗位需要更高学历' }
    ]
  },
  
  // 不建议考研的组合
  notRecommend: {
    conditions: [
      { primary: 'E', reason: '商业、管理类工作看能力不看学历，实践经验更重要' },
      { primary: 'A', reason: '艺术设计看作品和创意，学历帮助不大' },
      { combo: 'RA', reason: '手工艺、设计类工作，技术和作品比学历重要' }
    ]
  },
  
  // 视情况而定
  conditional: {
    S: '想进公立学校、三甲医院建议考研，培训机构、社工不需要',
    C: '考证比考研重要，但有好机会也可以考',
    R: '纯技术岗不用考研，想转技术管理可以考'
  }
};

// ==================== 5. 城市选择规则 ====================

export const CITY_RECOMMENDATIONS = {
  R: {
    tier1: ['深圳(制造业、硬件)', '苏州(制造业)', '宁波(工程)'],
    tier2: ['成都(基建)', '武汉(工程)', '重庆(制造)'],
    note: '制造业和工程项目分布广，二线城市机会也多'
  },
  I: {
    tier1: ['北京(科技总部)', '上海(外企研发)', '深圳(科技创新)', '杭州(互联网)'],
    tier2: ['成都(互联网)', '西安(科研院所)'],
    note: '一线城市研发机会多，薪资高，但竞争激烈'
  },
  A: {
    tier1: ['北京(文化产业)', '上海(创意产业)', '深圳(设计)', '杭州(电商设计)'],
    tier2: ['成都(游戏、文创)', '广州(广告)'],
    note: '一线城市创意产业发达，但也可以线上接单不受地域限制'
  },
  S: {
    tier1: ['北上广深(教育医疗资源丰富)', '杭州(教育产业)'],
    tier2: ['所有城市都有需求，二三线城市生活压力小'],
    note: '教育和社会服务在哪都需要，可以选择生活压力小的城市'
  },
  E: {
    tier1: ['北上广深(商业中心)', '杭州(电商)', '成都(西部商业中心)'],
    tier2: ['各省会城市都有机会'],
    note: '商业管理在经济发达城市机会更多，平台更好'
  },
  C: {
    tier1: ['北上广深(大企业总部)', '上海(金融中心)'],
    tier2: ['所有城市都需要财务行政人员'],
    note: '财务行政岗位需求稳定，哪里都能找到工作'
  }
};

// 组合城市特殊建议
export const COMBO_CITY_SPECIAL = {
  RI: '深圳、杭州的科技公司多，硬件+软件结合的机会多',
  RE: '北京、成都的大型工程项目多，适合技术管理',
  IA: '杭州、深圳的互联网公司需要懂技术的设计师',
  AS: '北上广深的文化教育产业发达',
  EA: '北京、上海的创意产业和商业结合好',
  SE: '所有城市都需要，可以选生活成本低的',
  EC: '一线城市的企业规范化程度高，学习机会多'
};

// ==================== 6. 过来人建议模板 ====================

export const LIFE_ADVICE_TEMPLATES = {
  // 组合优势描述
  advantages: {
    RI: '技术+研究是很好的组合，既能动手又能深入钻研',
    RA: '技术+创意让你在产品设计领域很有优势',
    RS: '技术+服务能让你的专业技能帮助更多人',
    RE: '技术+管理是最吃香的组合，既懂技术又会带团队',
    RC: '技术+细节让你在精密工作中如鱼得水',
    IA: '研究+创意让你能做出既有内涵又有美感的作品',
    IS: '研究+服务让你成为真正能帮助人的专家',
    IE: '研究+商业让你能把知识转化为价值',
    IC: '研究+规范让你在科研和质量管理中表现出色',
    AS: '艺术+沟通让你在文化教育领域大展拳脚',
    AE: '艺术+商业能让你的创意产生商业价值',
    AC: '艺术+细节让你的作品既美观又精致',
    SE: '沟通+管理让你成为优秀的团队领导',
    SC: '服务+规范让你在行政管理中表现稳定',
    EC: '管理+规范让你在运营管理中游刃有余'
  },
  
  // 注意事项
  cautions: {
    R_focus: '但要注意技术工作可能比较枯燥，要耐得住寂寞',
    I_focus: '但要避免过于理论化，要多实践多应用',
    A_focus: '但要注意收入可能不稳定，前期要有心理准备',
    S_focus: '但要注意情绪管理，避免过度付出影响自己',
    E_focus: '但要避免过于追求业绩而忽视团队和健康',
    C_focus: '但要注意培养灵活性，不要过于死板'
  },
  
  // 实用建议
  practical: [
    '多实习，了解行业真实情况，别只凭想象做决定',
    '建立作品集/项目经验，这比学历更能证明能力',
    '如果家里条件一般，先选能赚钱的方向，稳定后再追求理想',
    '保持学习热情，行业变化快，持续学习才能不被淘汰',
    '建立人脉网络，很多机会来自人脉而不是招聘网站',
    '平衡工作和生活，再好的工作也不值得透支健康'
  ],
  
  // 鼓励金句
  encouragement: [
    '记住：兴趣很重要，但先让自己活下来更重要！',
    '你的组合很有潜力，踏实努力，未来可期！',
    '坚持自己的方向，不要被别人的选择影响！',
    '前期会辛苦，但坚持下来就会看到回报！',
    '相信自己的选择，每条路都能走出精彩！',
    '不要因为一次测试就限制了自己的可能性，保持开放心态！'
  ]
};

// ==================== 7. 特殊组合定制文案（可选） ====================

// 对于特别常见或特殊的组合，可以添加完全定制的文案
// 这些定制文案会覆盖动态生成的内容
export const CUSTOM_RECOMMENDATIONS = {
  // ECR - 企业型+传统型+实际型（来自原网站数据）
  'ECR': [
    "📚 专业选择：可以选：工商管理、市场营销、国际经济与贸易、金融学、法学、政治学、公共管理等。建议选综合性大学或财经类院校。想创业的话，商科背景有帮助但不是必须的，实践经验更重要。",
    "🎯 大学规划：大一大二：多参加社团、学生会，锻炼组织能力。尝试做点小生意（如校园代理、摆摊）。大三：申请管培生实习（快消、互联网）或者做销售实习。大四：校招投管培生或销售岗，门槛相对较低。",
    "💰 薪资预期：销售应届：底薪3-6千+提成（做得好月入1-2万）。管培生：10-15万（快消、互联网的管培生项目不错）。创业的话，前几年基本赚不到钱，要有心理准备。建议先工作几年再创业。",
    "🎓 考研or工作：这类工作看能力不看学历，不建议考研。建议直接工作，在实践中学习。如果3-5年后想晋升，可以考个在职MBA。应届生读全日制MBA没啥意义，还要花一大笔钱。",
    "🏙️ 城市选择：销售在哪都能做，但一线城市客户质量高、提成多。想创业去深圳（创业氛围好）、杭州（互联网发达）。想做管理，大公司平台更好，北上广深的跨国企业、大型民企机会多。",
    "💡 过来人建议：兴趣很重要，但不是唯一考虑因素。还要看：这个专业/行业好不好就业、薪资能不能养活自己、工作强度能不能接受、父母支不支持。如果兴趣和现实有冲突，可以考虑折中方案（比如喜欢艺术但选UI设计而不是纯美术）。大学期间多尝试、多实习，找到真正适合自己的方向。不要因为一次测试就限制了自己的可能性！"
  ]
};

export default {
  MAJOR_BY_TYPE,
  COMBO_FEATURES,
  SCHOOL_TYPE_BY_PRIMARY,
  COLLEGE_ACTIVITIES,
  SALARY_DATA,
  COMBO_SALARY_MODIFIER,
  GRADUATE_RULES,
  CITY_RECOMMENDATIONS,
  COMBO_CITY_SPECIAL,
  LIFE_ADVICE_TEMPLATES,
  CUSTOM_RECOMMENDATIONS
};
